<i18n>
{
	"en": {
		"drawArea": "Draw Area",
		"moveMarkers": "Move Markers",
		"reset": "Reset",
		"cancel": "Cancel",
		"saveArea": "Save Area",
		"giveAreaName": "Give area a name",
		"save": "Save",
		"failedToFetch": "Failed to fetch area"
	},
	"no": {
		"drawArea": "Tegne område",
		"moveMarkers": "Flytt punkter",
		"reset": "Nullstill",
		"cancel": "Avbryt",
		"saveArea": "Lagre område",
		"giveAreaName": "Gi område et navn",
		"save": "Lagre",
		"failedToFetch": "Kunne ikke hente området"
	}
}
</i18n>
<template>
	<div class="loacations-map">
		<div class="map" >
			<TMap>
				<LeafletPm
					ref="LPm"
					:location="location"
					@editGeoJson="editGeoJson"
				/>
				<leaflet-marker
					v-for="(marker) of validTerminals"
					:ref="marker.id"
					:key="marker.id"
					:latitude="marker.latitude"
					:longitude="marker.longitude"
					:icon="terminalIcon"
					:markerOptions="markerOptions"
					preventRefreshMarkersOnMoveMap
				/>
			</TMap>
		</div>
		<div class="bottom-bar">
			<div class="buttons-left">
				<t-button
					appearance="minimal"
					class="button"
					iconBefore="polygon-filter"
					@click="drawArea"
				>{{ $t('drawArea') }}</t-button>
				<t-button
					appearance="minimal"
					class="button"
					iconBefore="select"
					@click="editArea"
				>{{ $t('moveMarkers') }}</t-button>
				<t-button
					appearance="minimal"
					class="button"
					iconBefore="cross"
					@click="removeArea"
				>{{ $t('reset') }}</t-button>
			</div>
			<div class="buttons-right">
				<t-button class="button" @click="cancel">{{ $t('cancel') }}</t-button>
				<t-button appearance="primary" class="button" @click="toggleSave">{{ $t('saveArea') }}</t-button>
			</div>
		</div>
		<div v-show="toggleSavePopup" class="save-popup">
			<div class="popup-header">
				<div class="popup-text">{{ $t('giveAreaName') }}</div>
				<div class="popup-close">
					<TIconButton
						aria-label="Close"
						appearance="transparent"
						type="bp"
						icon="cross"
						@click="toggleSave"
					/>
				</div>
			</div>
			<div class="popup-body">
				<t-text-input
					v-model="nameItem"
					width="180px"
					:placeholder="areaName"
					class="popup-input"
				/>
				<t-button appearance="primary" class="popup-button" @click="saveArea">{{ $t('save') }}</t-button>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from './store/locations.store.js';
import createIconMixin from '@/components/map/CreateIcon.mixin.js';

export default {
	name:'LocationsMap',
	mixins: [createIconMixin],
	data() {
		return {
			map: null,
			toggleSavePopup: false,
			geoJson: null,
			location: {},
			nameItem: '',
			polygonOptions: { color: '#735dd0' },
			prevRoute: null,
			searchValue: '',
			validTerminals: [],
			terminalIcon: null,
			markerOptions: {
				interactive: false
			}
		};
	},
	computed: {
		...mapState(['terminals']),
		areaName() {
			return this.$route.params && this.$route.params.areaId && this.location ? this.location.name : 'New Area';
		}
	},
	async mounted() {
		if ( this.$route.params.areaId) {
			try {
				this.location = await this.fetchSingleLocation(this.$route.params.areaId);
				if (!this.location) {
					console.log('location not found but didnt error');
				}
				this.setName(this.location.name);
				this.geoJson = this.location.area;
			} catch (e) {
				this.$notify({
					type: 'error',
					title: this.$t('failedToFetch')
				});
			}
		}
		this.terminalIcon = this.createIcon({
			iconName: 'office',
			iconType: 'bp',
		});
		await this.getTerminals();
		this.setupTerminalPoints();
	},
	methods:{
		...mapActions([
			'fetchSingleLocation',
			'addNewLocation',
			'editLocation',
			'setDialog',
			'getTerminals'
		]),
		drawArea() {
			this.$refs.LPm.drawArea();
		},
		editArea() {
			this.$refs.LPm.editArea();
		},
		removeArea() {
			this.$refs.LPm.removeArea();
		},
		setName(name) {
			this.nameItem = name;
		},
		editGeoJson(geoJson) {
			this.geoJson = geoJson && Array.isArray(geoJson.features) ? geoJson.features[0] : geoJson;
		},
		async saveArea() {
			if ( this.$route.params.areaId && this.geoJson) {
				this.editLocation({
					id: this.location.id,
					type:'polygon-filter',
					name: this.nameItem ? this.nameItem : this.location.name,
					area: this.geoJson
				});
				this.cancel();
			} else if (this.geoJson && this.nameItem) {
				await this.addNewLocation({
					id: this.nameItem,
					type:'polygon-filter',
					name: this.nameItem,
					area: this.geoJson
				});
				this.cancel();
			} else if (!this.geoJson && this.nameItem) {
				console.log('must draw item');
			} else if (!this.nameItem  && this.geoJson) {
				console.log('must name item');
			} else {
				console.log('must set name and draw item');
			}
		},
		cancel() {
			if (this.prevRoute) {
				this.setDialog(true);
				this.$router.push({
					path: this.prevRoute.path,
				});
			}
		},
		toggleSave() {
			this.toggleSavePopup = !this.toggleSavePopup;
		},
		setupTerminalPoints() {
			let points = [];

			this.terminals.forEach(item => {
				if (item.latitude && item.longitude) {
					points.push({
						id: item.id,
						latitude: item.latitude,
						longitude: item.longitude,
					});
				}
			});

			this.validTerminals = Object.freeze(points);
		},
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			vm.prevRoute = from;
			vm.thisRoute = to;
		});
	},
	beforeRouteUpdate(to, from, next) {
		next(vm => {
			vm.prevRoute = from;
			vm.thisRoute = to;
		});
	}
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/text';
.loacations-map {
	display: flex;
	flex-flow: column;
}
.map {
	display: flex;
	box-sizing: border-box;
	width: 100%;
	height: 100%;
}

.bottom-bar{
	display: flex;
	width: 100%;
	height: 50px;
}
.buttons-left{
	display: flex;
	flex-flow: row;
	padding: 10px;
}
.buttons-right{
	display: flex;
	flex-flow: row;
	margin-left: auto;
	padding: 10px;
}
.button{
	height: 30px;
	margin-left: 10px;
	margin-right: 10px;
}
.save-popup{
	position: absolute;
	background-color: #fff;
	display: flex;
	flex-flow: column;
	width: 320px;
	height: 90px;
	z-index: 999;
	right: 20px;
	bottom: 70px;
	padding: 5px 20px 10px;
	border-radius: 5px;
	box-shadow: 0 0 1px 0 rgba(67, 90, 111, 0.47);
}
.save-popup::before {
	content: " ";
	width: 0;
	height: 0;
	border-left: 12px solid transparent;
	border-right: 12px solid transparent;
	border-top: 12px solid #FFF;
	position:absolute;
	bottom: -12px;
	right: 50px;
}

.popup-header{
	display: flex;
	flex-flow: row;
	justify-content: space-between;
}
.popup-text{
	@extend %text-medium;
	font-weight: 500;
	line-height:1.9;
	display: flex;
}
.popup-x{
	display: flex;
	margin-left: auto;
}
.popup-body{
	display: flex;
	flex-flow: row;
	margin-top:auto;
}
.popup-input{
	display: flex;
}
.popup-button{
	margin-left: auto;
}

</style>
